<template>
  <div class="bg-white">
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :filename="`pdf_file_${$route.params.id}`"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-content-width="100%"
      ref="html2Pdf"
      @progress="onProgress($event)"
    >
      <section slot="pdf-content">
        <div id="pdf-content-area" class="p-3"></div>
      </section>
    </vue-html2pdf>
    <div class="action-btn-block p-1">
      <div class="px-10 w-full flex justify-between space-x-2">
        <button @click="$router.go(-1)" class="btn btn-app">{{ $t('Back') }}</button>
        <div>
          <button @click="print('210mm', '297mm')" class="btn btn-app">A4</button>
          <template v-for="(size, index) in $store.state.settings.printer_sizes">
            <button :key="index" @click="print(size, '200mm')" class="mr-1 mb-1 btn btn-app px-1">
              {{ size }}
            </button>
          </template>
        </div>
        <div>
          <button @click="generatePDF" class="btn btn-app">
            {{ $t('Download PDF') }}
            <template v-if="pdfProgress > 0"> {{ pdfProgress }}% </template>
          </button>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <div id="content-to-pdf" class="invoice-box bg-gray-50 rounded">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'Repair',
  metaInfo() {
    return {
      titleTemplate: this.$store.state.settings.name,
    };
  },
  components: { VueHtml2pdf },
  data() {
    return {
      loading: false,
      pdfProgress: 0,
      currentUrl: window.app.url,
    };
  },
  methods: {
    onProgress(e) {
      this.pdfProgress = e;
    },
    generatePDF() {
      this.loading = true;
      var x = document.getElementById('content-to-pdf').innerHTML;
      document.getElementById('pdf-content-area').innerHTML = x;
      this.$refs.html2Pdf.generatePdf();
      this.loading = false;
    },
    print(w, h) {
      this.loading = true;
      const element = document.createElement('style');
      element.innerHTML = `@page { margin: 0; size : ${w} ${h} }`;
      document.head.appendChild(element);
      window.print();
      this.loading = false;
    },
  },
};
</script>
<style>
.invoice-box {
  font-family: monospace;
  width: 97%;
  font-size: 12px;
  padding: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
}
@media (min-width: theme('screens.md')) {
  .invoice-box {
    width: 70%;
    font-size: 14px;
  }
}
@media print {
  .invoice-box {
    width: 100%;
    padding: 5px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .action-btn-block {
    display: none;
  }
}
</style>
